import React from 'react';
import './style.scss';
import { SearchBox } from 'views/components/atoms/searchBox';
import { SearchSelect } from 'views/components/atoms/searchSelect';
import { SearchToggle } from 'views/components/atoms/searchToggle';

type SearchNavProps = {
  submitSearch: (searchWord: string) => void;
  clearSearch: () => void;
  selectedOptionsData?: string[][];
  selectedOptions?: string[];
  setSelectedOptions?: ((selectedOption: string) => void)[];
  disabledOption?: string[];
  searchWord?: string;
  setSearchWord: (searchWord: string) => void;
  placeholder?: string;
};

export const SearchNav: React.FC<SearchNavProps> = ({
  submitSearch,
  clearSearch,
  selectedOptionsData,
  selectedOptions,
  setSelectedOptions,
  disabledOption,
  searchWord,
  setSearchWord,
  placeholder,
}) => {
  const [isToggle, setIsToggle] = React.useState<boolean>(true);
  const [isShowSearchSelects, setIsShowSearchSelects] = React.useState<boolean>(false);

  return (
    <div className="searchNav">
      <div className="searchNav_content">
        <SearchBox
          searchWord={searchWord}
          setSearchWord={setSearchWord}
          submitSearch={submitSearch}
          clearSearch={clearSearch}
          placeholder={placeholder}
        />
        {setSelectedOptions && (
          <SearchToggle
            isToggle={isToggle}
            onToggleOn={() => {
              setIsShowSearchSelects(true);
            }}
            onToggleOff={() => {
              setIsShowSearchSelects(false);
            }}
          />
        )}
      </div>
      {isShowSearchSelects && selectedOptions && setSelectedOptions && (
        <div className="searchNav_content">
          {selectedOptionsData?.map((item, index) => {
            return (
              <SearchSelect
                key={index}
                disabledOption={disabledOption && disabledOption[index]}
                options={item}
                selectedOption={selectedOptions[index]}
                setSelectedOption={setSelectedOptions[index]}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
